import takeMap from 'model/actions/story/takeMap';
import nextAction from 'model/actions/utilities/nextAction';

// Two voices. The narration is the traveler's and stays terse: it reports what a body does and
// never what a man feels. What the stranger says is his own — he is a frightened drunk who has
// been carrying this for months, so he babbles, repeats himself, trails off and begs. Do not
// tidy his lines into the narrator's register; the mess is the character.
//
// Event.js splits each line on /(".*?")/ and puts the match in .dialogue, so double quotes mean
// a mouth opened. The traveler's thought on the first screen goes bare.
//
// Every line he says has to carry two readings and commit to neither. The traveler hears a
// bystander sick with himself for running instead of helping, and that is what the player is
// meant to take away. What is actually happening is a frightened man confessing to the wrong
// crime, because he assumes the man in front of him already knows the rest of it.
//
// So he never protests his innocence. He used to (`i tried to stop it. i swear`), and it made no
// sense: he would be performing for the one man who was there and who outranks him in guilt.
// `i know what i did. i ran.` costs him nothing to say and means two different things depending
// on when you read it. Keep his lines on that footing — nothing that only works once.

const start = onNext => ({
  title: 'the stranger',
  description: [
    'a man watches from the shadows. been doing it for days',
    'i know the face. his coins went in the bowl once',
    'does he know me'
  ],
  buttons: [nextAction('Who are you', () => onNext(chase(onNext)))]
});

const chase = onNext => ({
  title: 'the stranger',
  description: [
    'he backs off. turns and runs',
    'drunk. the whiskey comes off him in the cold',
    '"wait." he does not stop. i catch him at the corner'
  ],
  buttons: [nextAction('Do you know me', () => onNext(recognize(onNext)))]
});

const recognize = onNext => ({
  title: 'the stranger',
  description: [
    'he looks down. then away',
    '"no. i... please... leave me be."',
    'his knees buckle',
    'i hold him up and look him in the eye and lie'
  ],
  buttons: [nextAction('I know you', () => onNext(fear(onNext)))]
});

const fear = onNext => ({
  title: 'the stranger',
  description: [
    'he is shaking. i can smell him',
    '"it wasn\'t right. i know what i did. i ran."',
    '"i have not had a night since."',
    'i say nothing'
  ],
  buttons: [nextAction('What happened', () => onNext(story(onNext)))]
});

const story = onNext => ({
  title: 'the stranger',
  description: [
    '"w... the boys..." his face comes apart',
    '"they said nobody would be hurt."',
    'he wipes his mouth with the back of his hand',
    '"i said stop. that night i said stop and they laughed at me and they run me off."'
  ],
  buttons: [nextAction('Wait', () => onNext(map(onNext)))]
});

const map = onNext => ({
  title: 'the stranger',
  description: [
    '"went back. days later i went back. nothing left. burnt rubble and buzzards. coyotes had feasted."',
    'he puts a folded paper in my hands',
    '"doesn\'t matter now. take it. just leave me be"',
    'he goes down in the dirt and does not get up'
  ],
  buttons: [takeMap(onNext)]
});

export default start;
